<template>
  <div class="container-fluid">
    <ProfileCard :key="user_id" :user_id="user_id"/>
  </div>
</template>


<script>
import ProfileCard from "@/components/profile/ProfileCard.vue";

export default {
  name: "ProfilePage",
  components: { ProfileCard },

  // club_id is for when the user gets here via a club -- we no longer use this for anything here
  props: ['user_id', 'club_id'],
}
</script>


<style scoped>
.container-fluid {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>